import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Trang chi tiết hộ giờ đã là màn sửa (khi có quyền ghi), nên đường dẫn cũ
 * /growers/$id/edit chỉ còn để link cũ và bookmark không vỡ: chuyển thẳng về
 * /growers/$id.
 */
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/growers/$id_/edit',
)({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/agriculture/growers/$id',
            params: { id: params.id },
            replace: true,
        })
    },
})
